<template>

  <div class="container">
    <div class="navbar">
      积分商城
    </div>
    <div class="wrap-list">
      <div class="card shadow" v-for="(item,index) in lists" :key="index">
        <div class="card-image-wrap">
          <el-image class="card-image" :src="item.image" fit="fill">
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
          </el-image>
        </div>
        <div class="card-info">
          <div class="card-info-title limit2">
            {{item.name}}
          </div>
          <div class="card-info-des limit2">{{item.describe}}</div>
          <div class="card-info-footer">
            <div class="card-info-footer-score">{{item.amount}}<span class="tips">积分</span></div>
            <div class="card-info-footer-btn" :class="[item.stock==0?'gray':'']" @click="exchange(item)">
              {{ item.stock == 0 ? '售罄' : '兑换' }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="提示" :visible.sync="exchangeDialogVisible" class="dialog">
      <div class="tipsText">
        请仔细核对手机号码，号码错误积分不退还。
      </div>
      <el-input class="form-input" v-model="form.mobile" placeholder="请输入电话号码"></el-input>
      <el-input v-if="select_item.type == 1" class="form-input" type="textarea" v-model="form.address"
        placeholder="请输入联系地址"></el-input>
      <el-input v-if="select_item.type == 1" class="form-input" type="textarea" v-model="form.remark"
        placeholder="请输入备注信息"></el-input>
      <span slot="footer" class="dialog-footer btn-area">
        <el-button @click="exchangeDialogVisible = false" class="btn">取 消</el-button>
        <el-button type="primary" @click="order" class="btn">确 定</el-button>
      </span>
    </el-dialog>
    <navBar :idx="3"></navBar>
  </div>

</template>

<script>
  import navBar from '@/components/navBar';
  export default {
    name: "exchange",
    components: {
      navBar
    },
    data() {
      return {
        exchangeDialogVisible: false,
        lists: [],
        form: {},
        select_item: {},
      }
    },
    mounted() {
      let auth_token = localStorage.getItem('auth_token');
      if (!auth_token) {
        this.$message({
          message: "请先登录！",
          type: "warning",
        })
        setTimeout(() => {
          this.$router.push('/');
        }, 2000);
      } else {
        this.load();

      }
    },
    methods: {
      load() {
        this.$api
          .request('Integral/goods')
          .then(({
            data
          }) => {
            this.lists = data;
          })
          .catch(error => {
            this.$message({
              message: error + "加载商城商品失败！",
              type: "warning"
            })
          });
      },
      exchange(goods) {
        if (goods.stock == 0) {
          return;
        }
        this.select_item = goods;
        if (goods.type > 2) {
          this.$confirm('确认兑换此商品吗?', '提示', {
            confirmButtonText: '确定?',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.order();
          }).catch(() => {});
        } else {
          this.exchangeDialogVisible = true;
        }
      },
      order() {
        this.form.id = this.select_item.id;
        this.$api
          .request('Integral/submit', this.form)
          .then(({
            data
          }) => {
            this.$message({
              message: "兑换成功",
              type: "success"
            })
            this.exchangeDialogVisible = false;
          })
          .catch(error => {
            this.$message({
              message: error,
              type: "warning"
            })
          });
      }
    }
  }
</script>


<style lang="less">
  .tipsText {
    font-size: 0.625rem;
    color: #000;
  }

  .form-input {
    margin: 5px 0;
  }

  .container {
    height: 100vh;
    background-color: #f9f9f9;

    .limit2 {
      overflow: hidden;
      text-overflow: ellipsis;
      /* 超出部分省略号 */
      word-break: break-all;
      /* break-all(允许在单词内换行。) */
      display: -webkit-box;
      /* 对象作为伸缩盒子模型显示 */
      -webkit-box-orient: vertical;
      /* 设置或检索伸缩盒对象的子元素的排列方式 */
      -webkit-line-clamp: 2;
      /* 显示的行数 */
      max-height: 80rpx;
      /* 设置最大高度，根据行高，要几行乘以几倍 */
    }

    .navbar {
      box-sizing: border-box;
      height: 3.125rem;
      margin-bottom: 1.25rem;
      border-bottom: 1px solid #ddd;
      box-shadow: 0 1px 2px #ddd;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1rem;
      font-weight: bold;
      background-color: var(--theme-color);
      color: #fff;

    }

    .shadow {
      box-shadow: 0 3px 6px rgba(0, 0, 0, .15);
      ;
    }

    .wrap-list {
      margin-left: 10px;
      margin-right: 10px;
      padding-bottom: 60px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .card {
        margin-bottom: 15px;
        border-radius: 15px;
        height: 5.625rem;
        width: calc(50vw - 15px);
        max-width: 350px;
        height: auto;
        display: flex;
        flex-direction: column;


        &-image-wrap {

          .card-image {

            width: 100%;
            height: calc(50vw - 15px);
          }

          img {


            border-radius: 15px 15px 0 0;
          }

          display: inline-block;
        }

        &-info {
          box-sizing: border-box;
          text-align: left;
          padding: 0.3125rem 0.625rem 10px;
          float: left;
          width: 100%;
          display: inline-block;

          &-title {
            font-size: 1.125rem;
            font-weight: bold;
            color: #333;
            margin-bottom: 5px;


          }

          &-des {

            font-size: 0.75rem;
            color: #909399;
            min-height: 32px;


          }

          &-footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;

            &-score {
              font-size: 0.875rem;
              font-weight: bold;
              color: #E6A23C;

              .tips {
                font-size: 0.875rem;
              }
            }

            &-btn {
              &.gray {
                background-color: #909399;
                opacity: .4;
              }

              margin-left: 5px;
              white-space: nowrap;
              float: right;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: var(--theme-color);
              color: #fff;
              border-radius: 15px;
              padding: 0.375rem 1.25rem;
              font-size: 0.75rem
            }


          }


        }


      }
    }
  }

  @media screen and (min-width:767px) {
    html {
      font-size: 24px;
    }

    .container .wrap-list {
      padding-bottom: 60px;
    }

    .container .wrap-list .card-image-wrap .card-image {
      height: 350px;
    }

    .card-image {
      width: 350px;
      height: 350px;
    }

    .container .wrap-list .card-info-des {
      min-height: 48px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/page/goods.vue